import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./RecentLessonCard.module.scss";
import {FontIcon, Icon} from "../../../../components/common/FontIcon";
import { useNavigate } from "react-router-dom";
import {IDashboardPageRecentlyPlayedLesson} from "../../store/IDashboardPageStore";

interface IRecentLessonCardProps extends IDashboardPageRecentlyPlayedLesson {
}

export const RecentLessonCard: VoidFunctionComponent<IRecentLessonCardProps> = ({thumbnailUrl, type, name, difficultyCategory, percentComplete, hashUrl}) => {
  const cardIcon = setCardIcon(type);
  const navigate = useNavigate();

  return <button className={s.recentLessonCard} onClick={() => navigate(hashUrl)}>
    <div className={s.cardContent}>
      <img className={s.cardImg} src={thumbnailUrl} alt={``} width={`60`} height={`60`} />
      <div className={s.cardLabels}>
        {cardIcon}
        <h3 className={s.cardTitle}>{name}</h3>
        <p className={s.cardSubtitle}>{difficultyCategory}</p>
      </div>
    </div>
    <progress className={s.lessonProgress} value={percentComplete} max={100} />
  </button>;

  function setCardIcon(type: string) {
    let iconClassName: Icon = `icon-bootcamp`;
    switch (type) {
      case 'bootcamp':
        iconClassName = `icon-bootcamp`;
        break;
      case 'song':
        iconClassName = `icon-songs`;
        break;
      case 'course':
        iconClassName = `icon-courses`;
        break;
    }
    
    return <FontIcon icon={iconClassName} />
  }
}
